import React from 'react';

import MarkerButton from '../markerButton';

import { IInteractiveContent, IInteractiveContentSubmissions } from '@interfaces/learning';
import { percentify } from 'src/helpers/utils';

export type VideoMarkerProps = {
  interactiveContents?: IInteractiveContent[];
  displayedInteractions: (IInteractiveContent | IInteractiveContentSubmissions)[];
  onMarkerClick?: (content: IInteractiveContent) => void;
  duration: number;
};

const VideoMarker = ({ interactiveContents, displayedInteractions, onMarkerClick, duration }: VideoMarkerProps) => {
  const renderMarker = () =>
    interactiveContents?.map((content) => {
      const isDisplayed = displayedInteractions.some((displayInteractive) => {
        const isArticleDisplayed =
          !!displayInteractive.article_id && displayInteractive.article_id === content.article_id;
        const isQuizDisplayed = !!displayInteractive.quiz_id && displayInteractive.quiz_id === content.quiz_id;
        return isArticleDisplayed || isQuizDisplayed;
      });

      return (
        <MarkerButton
          key={content.id}
          displayed={isDisplayed}
          displayPosition={percentify(content.display_point, duration)}
          onClick={() => onMarkerClick?.(content)}
        />
      );
    });

  return <>{renderMarker()}</>;
};
export default VideoMarker;
